import React, { useEffect, useState } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  Typography,
  MenuItem,
  Box,
  Menu,
  Switch,
  Grow,
  Avatar
} from "@material-ui/core"
import { openUpdateAccessDialog } from "actions/update-access-dialog"
import { useDispatch } from "react-redux"
import cloudinary from "cloudinary-core"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown"
import { setCanPost, updateRole } from "actions/organization"
import { openSnackBar } from "actions/snack-bar"
// import { getMembers } from "actions/organization"
const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const MembersCard = props => {
  const { classes, user } = props
  const {
    id,
    role,
    profile_image: profileImage,
    name,
    job,
    totalPosts,
    can_post: canPost
  } = user
  const options = [
    { name: "Administrator", id: 2 },
    { name: "Moderator", id: 3 },
    { name: "User", id: 4 }
  ]
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedIndex, setSelectedIndex] = useState(1)
  const [switchValue, setSwitchValue] = useState(true)
  const [disableSwitch, setDisableSwitch] = useState(false)
  const [disableMenu, setDisableMenu] = useState(false)

  const handleOpenUpdateAccess = () => {
    dispatch(openUpdateAccessDialog({ ...props, id }))
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuItemClick = (_e, index) => {
    const prevVal = selectedIndex
    setSelectedIndex(index)
    setAnchorEl(null)
    setDisableMenu(true)
    dispatch(updateRole(id, options[index].id))
      .then(() => {
        setDisableMenu(false)
      })
      .catch(() => {
        dispatch(openSnackBar({ message: "Error updating user role" }))
        setSelectedIndex(prevVal)
        setDisableMenu(false)
      })
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    const index = options.findIndex(x => x.name === role)
    if (index !== -1) {
      setSelectedIndex(index)
    }
  }, [role])

  useEffect(() => {
    setSwitchValue(canPost)
  }, [canPost])

  const handleChangeSwitch = () => {
    setDisableSwitch(true)
    dispatch(setCanPost(id, !switchValue))
      .then(() => {
        setDisableSwitch(false)
        setSwitchValue(!switchValue)
      })
      .catch(err => {
        dispatch(openSnackBar({ message: err.message }))
        setDisableSwitch(false)
      })
  }
  return (
    <Grow in timeout={500} style={{ transformOrigin: "50% 50%" }}>
      <Card className={classes.cardContainer}>
        <Box position="relative">
          {profileImage ? (
            <CardMedia
              classes={{ root: classes.root }}
              component="img"
              height="140"
              src={cl.url(profileImage, {
                width: 350,
                height: 140,
                crop: "crop",
                gravity: "auto"
              })}
            />
          ) : (
            <Box
              className={classes.noPictureForProfile}
              style={{ width: 350, height: 140 }}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Avatar className={classes.noPictureAvatar}>
                {user.first_name ? user.first_name.split("").splice(0, 1) : ""}
                {user.last_name ? user.last_name.split("").splice(0, 1) : ""}
              </Avatar>
            </Box>
          )}

          <div>
            <Button
              variant="contained"
              className={classes.menu}
              onClick={handleClick}
              disabled={disableMenu}
              style={{
                background: disableMenu ? "rgb(200, 200, 200)" : ""
              }}
            >
              <ArrowDropDownIcon /> {options[selectedIndex].name}
            </Button>
            <Menu
              id="role-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {options.map((option, i) => (
                <MenuItem
                  key={i}
                  selected={i === selectedIndex}
                  onClick={event => handleMenuItemClick(event, i)}
                >
                  {option.name === options[selectedIndex].name ? (
                    <Typography className={classes.job}>
                      {option.name}
                    </Typography>
                  ) : (
                    <Typography>{option.name}</Typography>
                  )}
                </MenuItem>
              ))}
            </Menu>
          </div>
        </Box>
        <CardContent>
          <Box>
            <Typography className={classes.name} variant="h3">
              {name}
            </Typography>
            <Typography variant="subtitle1" color="secondary">
              {job}
            </Typography>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            className={classes.switchContainer}
          >
            <Box display="flex">
              <Switch
                checked={Boolean(switchValue)}
                onChange={handleChangeSwitch}
                color="primary"
                disabled={disableSwitch}
              />
            </Box>
            <Typography variant="body1" className={classes.canPostContianer}>
              Can submit?
            </Typography>
          </Box>
        </CardContent>
        <CardActions>
          <Box flexGrow={1} className={classes.postPublishedContainer}>
            <Typography color="secondary">
              Post
              <br />
              published
            </Typography>
            <Typography variant="h4" className={classes.totalPosts}>
              {totalPosts}
            </Typography>
          </Box>
          <Button
            onClick={e => handleOpenUpdateAccess(e)}
            variant="contained"
            color="primary"
          >
            View Profile
          </Button>
        </CardActions>
      </Card>
    </Grow>
  )
}

export default withStyles(styles)(MembersCard)



// WEBPACK FOOTER //
// ./src/components/MembersCard/index.jsx